import { render, staticRenderFns } from "./WelligentPane.vue?vue&type=template&id=ca1d37a0&scoped=true&"
import script from "./WelligentPane.vue?vue&type=script&lang=js&"
export * from "./WelligentPane.vue?vue&type=script&lang=js&"
import style0 from "./WelligentPane.vue?vue&type=style&index=0&id=ca1d37a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d37a0",
  null
  
)

export default component.exports